import { useState } from "react";
import { useTradeInAemSelector } from "../redux/store";
import type { TradeInLinkPropsType } from "../utils/navUtils";
import {
    tradeInAemContactCheckboxIds,
    TradeInAemContactFormId,
    tradeInAemContactTextItemIds,
} from "../utils/constants";

type UseTradeInAemContactFormType = {
    confirmClick: (event: React.SyntheticEvent) => void;
    showRequiredErrors: boolean;
};

const useTradeInAemContactForm = (nextStep: TradeInLinkPropsType): UseTradeInAemContactFormType => {
    const contactForm = useTradeInAemSelector((state) => state.tradeInAemContact);
    const [showRequiredErrors, setShowRequiredErrors] = useState<boolean>(false);

    const showRadioButtons = contactForm[TradeInAemContactFormId.PrivacyDisclaimers]?.visualization === "radiobutton";

    const confirmClick = (event: React.SyntheticEvent): void => {
        event.preventDefault();

        // Check if all required form items are filled in.
        // To try to keep the setup simple there is no external validation logic (yet), similar to vehicleDetails.
        // Everything is happening inside the React components.
        let requiredEmpty = false;
        tradeInAemContactTextItemIds.forEach((itemId) => {
            if (contactForm[itemId] && contactForm[itemId]?.required && !contactForm[itemId]?.value) {
                requiredEmpty = true;
            }
        });

        tradeInAemContactCheckboxIds.forEach((itemId) => {
            const isRadioButton = showRadioButtons && itemId === TradeInAemContactFormId.PrivacyDisclaimers;

            if (contactForm[itemId]) {
                // A required radiobutton is valid once the selected state was changed (in other words when interacted is true)
                // A required select box is valid if it is selected
                const requiredEmptyValue = !!contactForm[itemId]?.items.find(
                    (item) => item.required && (isRadioButton ? !item.interacted : !item.selected),
                );
                if (requiredEmptyValue) requiredEmpty = true;
            }
        });

        if (requiredEmpty) setShowRequiredErrors(true);
        else if (nextStep.onClick) nextStep.onClick(event);
    };

    return { showRequiredErrors, confirmClick };
};

export default useTradeInAemContactForm;
